import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'm-notificacion-pt',
  templateUrl: './notificacion-pt.component.html',
  styleUrls: ['./notificacion-pt.component.css']
})
export class NotificacionPTComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
